import { useState } from "react"
import { defaultPrimitive, ILandingPrimitive, ILandingSection, IconContent } from "src/modules/pe-landing-module/data/interfaces"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import "../../../assets/css/Image.scss"
import { IconPrimitive } from "../primitive"
import DataContentEditor from "../landing-edit/editors/data-content-editor"

/* Protopia Ecosystem component */
export interface IImageProps {
    section: ILandingSection
    data: IconContent 
}
const Icon = ({ section, ...props}: IImageProps): JSX.Element => {
    const data: IconContent = props.data as IconContent
    
    // console.log( data )
    
    const [width]         = useState<string>(
        getCssDemention( 
            data.size,  
            getCssDemention( section.width, "100%") 
        )
    )
    const [height, ]      = useState<string>(
        getCssDemention( 
            data.size, 
            getCssDemention(
                section.height, 
                "100%"
            ) 
        )
    )    
    const primitive: ILandingPrimitive = {
        ...defaultPrimitive(), 
        id:  data.id || section.id,
        data: {
            ...data,
            width,
            height,
            style: {
                ...data.style,
                width,
                height,
            }
        },
        position: {
            width,
            height  
        } 
    }  
    return <div className={`landing-content-container landing-icon landing-icon-cont-${props.data.id} ${ data.className || "" } `}   data-type={data.type} data-content-id={data.id}>
        <IconPrimitive
            primitive={ primitive }
        />
        <DataContentEditor data={data} section={props.section} />
    </div>
}
export default Icon
 